module.exports = __webpack_public_path__ + "static/media/promotion_01.9855e7b4.jpg";